/* eslint-disable react/prop-types */
import { LoadingBackdrop } from '@olxbr/design-system';

type Props = {
  visible: boolean;
};

const Loading = ({ visible }: Props) => (visible ? <LoadingBackdrop /> : null);

export default Loading;
